module.exports = __webpack_public_path__ + "img/star.373a30e6.svg";